$('#numberListViewsProspect').val(arvViewsProspect);
function deleteNew(id){
    idDeleteViewsProspect = id;
    $('.contact-add'+idDelete).remove();
    scriptArViewsProspect[id] = "no";
    arvViewsProspect = scriptArViewsProspect.toString();
    $('#numberListViewsProspect').val(arvViewsProspect);
}
$( document ).ready(function() {
    $('.add-new-contact-2').click(function () {
        $('.add-new-contact-2').css('visibility','hidden');
        numberListViewsProspect = numberListViewsProspect + 1;
        scriptArViewsProspect[numberListViewsProspect] = "new";
        arvViewsProspect = scriptArViewsProspect.toString();
        $('#numberListViewsProspect').val(arvViewsProspect);
        $('.moreContact').append('' +
            '<div class="container-createClient">\n' +
            '    <div class="container-select-2">\n' +
            '        <div class="row">\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    <span>Contacto</span> 0'+numberListViewsProspect+'\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l8">\n' +
            '                <h1 class="align-center">\n' +
            '                    Datos de contacto\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h3 class="add-new-contact-2" onclick="$(\'#add-new-contact-2\').click();"">\n' +
            '                    <img src="'+https+'img/icons/add_purple_circle.svg" alt="">\n' +
            '                    Agregar Contacto\n' +
            '                </h3>' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="form align-center">\n' +
            '        <div class="row">\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Nombre\n' +
            '                </h1>\n' +
            '                <input id="name_'+numberListViewsProspect+'" name="name_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    Cargo\n' +
            '                </h1>\n' +
            '                <input id="position_'+numberListViewsProspect+'" name="position_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Departamento\n' +
            '                </h1>\n' +
            '                <input id="department_'+numberListViewsProspect+'" name="department_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l4">\n' +
            '                <h1>\n' +
            '                    Mail\n' +
            '                </h1>\n' +
            '                <input id="mail_'+numberListViewsProspect+'" name="mail_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '        </div>\n' +
            '        <div class="row">\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Telefono\n' +
            '                </h1>\n' +
            '                <input id="phone_'+numberListViewsProspect+'" name="phone_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l1">\n' +
            '                <h1>\n' +
            '                    Ext\n' +
            '                </h1>\n' +
            '                <input id="ext_'+numberListViewsProspect+'" name="ext_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Celular\n' +
            '                </h1>\n' +
            '                <input id="cellphone_'+numberListViewsProspect+'" name="cellphone_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l5">\n' +
            '                <h1>\n' +
            '                    Nota\n' +
            '                </h1>\n' +
            '                <input id="note_'+numberListViewsProspect+'" name="note_'+numberListViewsProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>');
    });
});

$(".btnUpdateProspect").click(function() {
    $("#formUpdateProspect").submit();
});

$("#formUpdateProspect").on("submit", function(e) {
    e.preventDefault();
    elementsForm = [
        "status_prospects",
        "name",
        /*
        "nit",
        "web",
        "web_status",
        "address",
        "city",
        "phone",
        "mail",
        "sector",
         */
        "numberListViewsProspect",
        "idViewsProspect"
    ];

    /*
    for(i=0;i<scriptArViewsProspect.length;i++){
        if(scriptArViewsProspect[i] == 'si'){
            elementsForm.push('name_'+i);
            elementsForm.push('position_'+i);
            elementsForm.push('department_'+i);
            elementsForm.push('mail_'+i);
            elementsForm.push('phone_'+i);
            elementsForm.push('cellphone_'+i);
            elementsForm.push('note_'+i);
        }
    }
    */

    contLogin = validationForm(elementsForm, (contLogin = 1));

    if (contLogin == 0) {
        swal({
            text: "Debes completar todos los datos",
            icon: imageURL,
            button: "OK!"
        });
        return false;
    }

    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false
    });
    var data = $(this).serialize();
    $.ajax({
        url: https + "updateProspect",
        method: "POST",
        data: data,
        success: function(data) {
            if ($.trim(data) == "1") {
                //$("#formUpdateProspect")[0].reset();
                swal.close();
                swal({
                    text: "Prospecto Actualizado con exito",
                    icon: imageURL,
                    button: "OK!"
                });
            } else if ($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!"
                });
            } else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!"
                });
            }
        }
    });
});

function validationForm(elementsForm, contLogin) {
    for (var i = 0; i < elementsForm.length; i++) {
        $("#" + elementsForm[i]).removeClass("error");

        if ($.trim($("#" + elementsForm[i]).val()) == "") {
            contLogin = 0;
            $("#" + elementsForm[i]).addClass("error");
        }
    }

    return contLogin;
}

$(".convertClient").click(function() {
    var id = this.id;
    convertToClient(id);
});

function convertToClient(id) {
    swal({
        title: "¿Seguro de hacer esto?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true
    }).then(willDelete => {
        if (willDelete) {
            //codigo para convertir en cliente...
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                }
            });

            function Error(obj,msg) {
                if(obj.length>0){
                    let camposError='';
                    for (const key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            const element =obj[key];
                            if($('#'+element).length=1){
                                $('#'+element).addClass("error");
                                camposError+=element+'\n';

                                console.log(element);
                            }
                            
                        }
                      
                    }
                    swal({
                        title: msg,
                        text: '',
                        icon: "warning",
                        buttons: true,
                        dangerMode: true
                    });
                    $("#convertClient").prop("checked", false);
                }
            }

            $.ajax({
                url: https + "prospectToclient",
                method: 'POST',
                data: { id: $('#idViewsProspect').val() },
                success: function(data) {
                    console.log(data);
                    const exist = data.error.exist;
                    const update = data.error.update;
                    let vali=false;
                    if(exist.length>0){
                        Error(exist, "Ya existe el nit "+$('#nit').val());
                        vali=true;
                    }

                    if(update.length>0){
                        Error(exist, "actualize el nit antes de esta acción");
                        vali=true;
                    }
                    if(vali==false){
                        swal({
                            title: 'Correcto',
                            text: '',
                            icon: "warning",
                            buttons: true,
                            dangerMode: true
                        });
                        
                        window.location.href=https+"client/contract/"+data.idClientnew;
                    }
                },
                error: function(e) {
                    console.error(e);
                }
            });
        } else {
            $("#convertClient").prop("checked", false);
            return false;
        }
    });
}
